(function() {
    'use strict';
    angular.module('nasracApp').factory('Feedback', Feedback);

    Feedback.$inject = [ '$resource' ];

    function Feedback($resource) {
        var resourceUrl = 'api/feedback';

        return $resource(resourceUrl, {}, {
            'saveFeedbackForm': {
                method:'POST'
            },
        });
    }
})();
